import { render, staticRenderFns } from "./TaxasParametrizadas.vue?vue&type=template&id=089d9fc6"
import script from "./TaxasParametrizadas.vue?vue&type=script&lang=js"
export * from "./TaxasParametrizadas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports